import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../Common/Loader/loader";
import MUITable from "../../../../../Common/MUITable";
import { useTripStore } from "../../store/useTripStore";
import { ExportSATTripReport } from "./ExportSATTripReport";
import { formatDateTime, formatDateTimeWithoutSec, getCurrentDateTime1 } from "../../../../../Common/helper/helpar";

const SATTripReport = () => {
  const { tripDetails, isFetchingTripDetails } = useTripStore();
  const navigate = useNavigate();
  const { state } = useLocation();

  // State for text filters
  const [circleFilter, setCircleFilter] = useState("");
  const [vehicleNumberFilter, setVehicleNumberFilter] = useState("");
  const [tsNameFilter, setTsNameFilter] = useState("");

  // Filter trip details based on user input
  const filteredTripDetails = tripDetails.filter(row => {
    const matchesCircle = circleFilter
      ? row.circle.toLowerCase().includes(circleFilter.toLowerCase())
      : true;
    const matchesVehicleNumber = vehicleNumberFilter
      ? row.vehicleNumber.toLowerCase().includes(vehicleNumberFilter.toLowerCase())
      : true;
    const matchesTsName = tsNameFilter
      ? row.transferStationName.toLowerCase().includes(tsNameFilter.toLowerCase())
      : true;
    return matchesCircle && matchesVehicleNumber && matchesTsName;
  });
  const columns = [
    {
      label: "Zone",
      field: "zone",
    },
    {
      label: "Circle",
      field: "circle",
    },
    {
      label: "Ward",
      field: "ward",
      width: 150,
    },
    {
      label: "Vehicle Type",
      field: "vehicleType",
      width: 200,
    },
    {
      label: "Vehicle Number",
      field: "vehicleNumber",
    },
    {
      label: "TS Name",
      field: "transferStationName",
    },
    {
      label: "Driver Name",
      field: "driverName",
    },
    {
      label: "Contact No",
      field: "driverNumber",
    },
    {
      label: "SFA Name",
      field: "primaryDeploymentInchargeName",
    },
    {
      label: "SFA Contact No",
      field: "primaryDeploymentInchargeMobileNumber",
    },
    {
      label: "Trips to TS/SCTP",
      field: "trips",
      render: row => row.trips
    },
    {
      label: "Reported Time",
      field: "scannedDateTime",
      render: row => row.scannedDateTime ? formatDateTime(row.scannedDateTime) : "N/A"
    },
  ];

  return (
    <>
      <div className="content">
        <div className="page-content">
          <div className="page-header">
            <div className="card">
              <div className="card-body">
                {/* Combined Filter and Buttons Section */}
                <div className="filter-section mb-3">
                  <div className="row align-items-end">
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">Circle</label>
                      <input
                        id="circleFilter"
                        type="text"
                        className="form-control"
                        value={circleFilter}
                        onChange={(e) => setCircleFilter(e.target.value)}
                        placeholder="Enter Circle name..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">
                        Vehicle Number
                      </label>
                      <input
                        id="vehicleNumberFilter"
                        type="text"
                        className="form-control"
                        value={vehicleNumberFilter}
                        onChange={(e) => setVehicleNumberFilter(e.target.value)}
                        placeholder="Enter Vehicle Number..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label w-100 text-left">
                        TS Name
                      </label>
                      <input
                        id="tsNameFilter"
                        type="text"
                        className="form-control"
                        value={tsNameFilter}
                        onChange={(e) => setTsNameFilter(e.target.value)}
                        placeholder="Enter TS Name..."
                      />
                    </div>
                    <div className="col-md-3 d-flex">
                      <button
                        className="btn btn-secondary "
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>
                      <ExportSATTripReport data={filteredTripDetails} datas={state}/>
                    </div>
                  </div>
                </div>
                <div className="top-header">
                  <span>
                    {state.circleName} {state.zoneName} {state.colName}
                    ({formatDateTimeWithoutSec(state.FromDateTime)} To
                    {formatDateTimeWithoutSec(state.ToDateTime)})
                    (at {getCurrentDateTime1()})
                  </span>
                </div>
                <div>
                  {isFetchingTripDetails && <Loader />}
                  <MUITable
                    needSRNumber
                    rows={filteredTripDetails}
                    columns={columns}
                    tableHeight={500}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SATTripReport;